import enumeration from "./enumeration";

const EndOfDayReportStatus = {
  OPEN: "OPEN",
  CLOSING: "CLOSING",
  CLOSED: "CLOSED",
};

export default enumeration(EndOfDayReportStatus);
